/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ads_Dialog_TotalInputs */

const en_directory_ads_dialog_total = /** @type {(inputs: Directory_Ads_Dialog_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total (one-time)`)
};

const zh_directory_ads_dialog_total = /** @type {(inputs: Directory_Ads_Dialog_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合计（一次性）`)
};

/**
* | output |
* | --- |
* | "Total (one-time)" |
*
* @param {Directory_Ads_Dialog_TotalInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ads_dialog_total = /** @type {((inputs?: Directory_Ads_Dialog_TotalInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ads_Dialog_TotalInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ads_dialog_total(inputs)
	return zh_directory_ads_dialog_total(inputs)
});
export { directory_ads_dialog_total as "directory.ads.dialog_total" }